export const DEFAULT_PAGE_META = {
  title: "ABillion Analytics - by Atharva System",
  description: "",
};

const PAGE_META: Record<string, { title: string; description: string }> = {
  "/dashboard": {
    title:
      "NSE Stocks Research Platform for Swing Traders | ABillion Analytics",
    description:
      "Discover data-driven insights for NSE stocks for smart swing traders who believe in market research and investing in high-probability opportunities with ABillion Analytics.",
  },
  "/analyze-stock": {
    title: "Analyze NSE Stocks | ABillion Analytics",
    description:
      "Get detailed NSE stock analysis with candlestick patterns, RSI trends, technical indicators, and fundamental ratios using ABillion Analytics.",
  },
  "/pattern-insights": {
    title: "Pattern Insights for NSE Stocks & Sectors | ABillion Analytics",
    description:
      "Discover sector performance trends, pattern insights, and individual stock patterns for NSE stocks using data-driven analysis by ABillion Analytics.",
  },
  "/insider-trading": {
    title: "Track Insider Trading Activity in NSE Stocks | ABillion Analytics",
    description:
      "Analyze insider trading, substantial activity, and promoter or director transactions in NSE stocks using advanced market insights from ABillion Analytics.",
  },
  "/sector-momentum": {
    title: "Sector Momentum Analysis for Nifty | ABillion Analytics",
    description:
      "Discover week-over-week sector analysis, sector rankings, and Nifty sector trends like Nifty IT, Nifty Metal, and more with ABillion Analytics.",
  },
  "/news": {
    title: "Current News That Affect Stock Market | ABillion Analytics",
    description:
      "Analyze current news based on PESTLE analysis, market sentiment, and their impact on NSE stocks and sectors using ABillion Analytics.",
  },
  "/order-block": {
    title: "NSE Order Block & Supply Demand Analysis | ABillion Analytics",
    description:
      "Discover order block insights, supply & demand indicators, and stock movement analysis for NSE stocks using ABillion Analytics.",
  },
  "/portfolio": {
    title: "Create Your NSE Stock Portfolio | ABillion Analytics",
    description:
      "Track portfolio performance, investment capital, and liquidity to make smarter stock market decisions with ABillion Analytics.",
  },
  "/support": {
    title: "Looking for Support Representative | Connect ABillion Analytics",
    description:
      "Need help? Contact ABillion Analytics via call, query, or demo request. Our team is ready to assist you anytime. Reach out and get the support you need today.",
  },
  "/portfolio/[portfolio_id]/timeline": {
    title: "Track Your Portfolio Performance | ABillion Analytics",
    description:
      "Track and manage your investment portfolio daily with ABillion Analytics. Make smarter decisions, maximize returns, and minimize risk. Get your free trial now.",
  },
  "/watchlist": {
    title: "Monitor Tracked Stocks and Price Alerts | ABillion Analytics",
    description:
      "Never miss a stock price movement. ABillion Analytics lets you track stocks and receive instant price alerts — so you're always one step ahead of the market.",
  },
  "/screener": {
    title: "Stock Recommendation on 23 Stock Metrics",
    description:
      "Find the best stocks faster with ABillion Analytics' smart stock screener. Filter by key financial metrics and make confident investment decisions. Start your free trial today.",
  },
  "/pastPerformance": {
    title: "Best Stock Selection in Past by ABillion Analytics",
    description:
      "Want to check the past performance of the stock selected by ABillion Analytics? See past peak return, current return for any given date.",
  },
  "/unsubscribe": {
    title: "Unsubscribe | ABillion Analytics",
    description: "Unsubscribe from ABillion Analytics emails.",
  },
};

export const getPageMeta = (pathname: string) =>
  PAGE_META[pathname] ?? DEFAULT_PAGE_META;
